/** WhatsApp service-messages charging cutover: 30 September 2026, 12:00 UTC */
export const WA_SERVICE_MESSAGES_CHARGE_STARTS_AT = Date.UTC(2026, 8, 30, 12)

/** Pre-announcement banner stays up for 1 week after the cutover */
export const WA_SERVICE_MESSAGES_CHARGE_BANNER_ENDS_AT = Date.UTC(2026, 9, 7, 12)

export const hasWaServiceMessagesChargeStarted = (now = Date.now()) =>
  now >= WA_SERVICE_MESSAGES_CHARGE_STARTS_AT

export const isWaServiceMessagesChargeBannerVisible = (now = Date.now()) =>
  now < WA_SERVICE_MESSAGES_CHARGE_BANNER_ENDS_AT
